import api from './api';
import {
  WalletTransaction,
  WalletSummary,
  TopupRequest,
  TopupRequestData,
  WalletFilters,
} from '@/types/wallet.types';
import { PaginatedResponse } from '@/types';

export const walletService = {
  // Get current wallet balance
  getBalance: () => api.get<{ balance: number }>('/wallet/balance'),

  // Get transaction history with pagination
  getTransactions: (filters?: WalletFilters, page = 1, limit = 20) =>
    api.get<PaginatedResponse<WalletTransaction>>('/wallet/transactions', {
      params: { ...filters, page, limit },
    }),

  // Get wallet summary (balance, credits, debits this month)
  getSummary: () => api.get<WalletSummary>('/wallet/summary'),

  // Request a wallet topup
  requestTopup: (data: TopupRequestData) =>
    api.post<TopupRequest>('/wallet/topup', data),

  // Get user's topup requests - returns { topupRequests: [...] }
  getMyTopupRequests: () =>
    api.get<{ topupRequests: TopupRequest[] }>('/wallet/topup-requests'),
};

export default walletService;
